import Vue from 'vue';
import Vuex from 'vuex';

// ----------------------------- o

import config from './config/index';
import global from './global/index';

// ----------------------------- o

import auth from './auth/auth';
import register from './auth/register';
import restore from './auth/restore';

// ----------------------------- o

import contact from './user/contact';
import employees from './user/employees';
import facilities from './user/facilities';
import profile from './user/profile';

// ----------------------------- o

import clients from './clients/clients';

// ----------------------------- o

import academies from './knowledge/academies';
import news from './knowledge/news';
import trainings from './knowledge/trainings';
import wikis from './knowledge/wikis';

// ----------------------------- o

import shopGlass from './shop/glass';

// ----------------------------- o

import loyalty from './loyalty/index';

// ----------------------------- o

Vue.use(Vuex)

// ----------------------------- o

export default new Vuex.Store({
    modules: {
        config,
        global,
        auth,
        register,
        restore,
        profile,
        employees,
        facilities,
        contact,
        academies,
        news,
        trainings,
        wikis,
        shopGlass,
        clients,
        loyalty
    },
})
